import React from 'react'
import ProfileNotifications from 'src/app/ProfileNotifications/ProfileNotifications'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { profileNotificationsRouteProps } from 'src/navigation/routeProps'

const ProfileNotificationsAppRoute: AppRoute = {
  id: AppLocation.ProfileNotifications,
  routeProps: profileNotificationsRouteProps,
  component: <ProfileNotifications />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ProfileNotificationsAppRoute
